import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Routes } from '@angular/router';
import { Http, HttpModule, JsonpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AComponentModule } from '../component/aComponent.module';

import { FormsModule } from '@angular/forms';

import { AuthGuard } from '../service/auth-guard.service';
import { XhrService } from '../service/xhr.service';
import { RootService } from '../service/root.service';
import { ToastService } from '../service/toast.service';

import { DialogModule,OverlayPanelModule } from 'primeng/primeng';
import { ConfirmationService, GrowlModule } from 'primeng/primeng';
import { ConfirmDialogModule,DragDropModule,PanelModule } from 'primeng/primeng';
import {PaginatorModule} from 'primeng/primeng';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { SortablejsModule } from 'angular-sortablejs';
import {CodemirrorModule} from 'ng2-codemirror';
import { PopoverModule } from 'ng2-pop-over';

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

var modules = [PaginatorModule,PanelModule,PopoverModule,SortablejsModule,CodemirrorModule,GrowlModule, DragDropModule,OverlayPanelModule, ConfirmDialogModule, DialogModule, BrowserAnimationsModule, FormsModule, BrowserModule, HttpModule, JsonpModule, AComponentModule];

var services = [ConfirmationService];
@NgModule({
  imports: [...modules,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    }
  })],
  declarations: [],
  providers: [...services,RootService,ToastService,XhrService,AuthGuard],
  exports: [...modules,TranslateModule]
})
export class ShareModule { }


// WEBPACK FOOTER //
// ./src/app/shared/share.module.ts